import { postData } from 'helpers/RequestHelper';
import { SET_DATA } from 'helpers/Constants';
import { setNextPage, submitData } from 'reg_redesign/actions';

const checkTurndownsAndSubmit = (callback) => {
  return async (dispatch, getState) => {
    dispatch({
      type: SET_DATA,
      payload: {
        submitLoading: true
      }
    });

    await submitData(getState());

    try {
      const response = await postData({
        url: '/registrations/check_turndown_vendors',
        body: {}
      });
      if (response?.data?.vendor) {
        window.location.href = '/registrations/turndown_offers';
      } else {
        dispatch(setNextPage(callback));
        dispatch({
          type: SET_DATA,
          payload: {
            submitLoading: false
          }
        });
      }
    } catch (e) {
      dispatch(setNextPage(callback));
      dispatch({
        type: SET_DATA,
        payload: {
          submitLoading: false
        }
      });
    }
  };
};

export default checkTurndownsAndSubmit;
